import { useSelector } from 'react-redux'

const useAuthorization = () => {
  return useSelector(state => state.authorization)
}

export default useAuthorization
